import React from 'react';
// Import Link if using React Router for internal navigation
// import { Link } from 'react-router-dom';

const HospitalityPathways = () => {
    // Navigation Links Data
    const navLinks = [
       
    ];

    // Pathway Data (extracted for clarity)
    const phases = [
        {
            title: 'Part 1: Foundational Skills (Units 1-40)',
            focus: 'Core grammar, basic vocabulary, and polite, professional interactions.',
            units: [
                { id: 1, title: 'Professional Introductions', desc: 'Mastering the art of a polite greeting and self-introduction.' },
                { id: 5, title: 'Guest Check-in Procedure', desc: 'Learn to guide guests through the check-in process smoothly and efficiently.' },
                { id: 12, title: 'Basic Question & Answer', desc: 'Practice asking and answering simple questions about hotel services.' },
                { id: 20, title: 'Giving Directions & Information', desc: 'Communicate clearly and concisely about locations within the hotel and surrounding area.' },
                { id: 35, title: 'Handling Simple Requests', desc: 'Respond to common guest needs like extra towels or an iron.' },
            ]
        },
        {
            title: 'Part 2: Intermediate Skills (Units 41-90)',
            focus: 'Advanced service scenarios, complaint resolution, and detailed communication.',
            units: [
                { id: 45, title: 'Resolving Common Complaints', desc: 'Use empathetic language to address issues and offer solutions.' },
                { id: 58, title: 'Upselling & Cross-Selling Services', desc: 'Promote hotel amenities and special offers to enhance the guest experience.' },
                { id: 70, title: 'Managing Unexpected Situations', desc: 'Practice speaking calmly and clearly when facing unexpected challenges.' },
                { id: 82, title: 'Communicating with Vendors', desc: 'Use professional language to coordinate with external service providers.' },
                { id: 90, title: 'Describing Hotel Amenities in Detail', desc: 'Provide comprehensive and compelling descriptions of all hotel facilities.' },
            ]
        },
        {
            title: 'Part 3: Advanced Skills (Units 91-148)',
            focus: 'High-pressure scenarios, crisis management, and leadership language.',
            units: [
                { id: 105, title: 'Responding to a Public Relations Crisis', desc: 'Formulate professional responses to protect the hotel’s reputation under public scrutiny.' },
                { id: 120, title: 'Leading an Emergency Response', desc: 'Issue clear and confident instructions during emergencies like fire or medical incidents.' },
                { id: 135, title: 'Negotiating with VIP Guests', desc: 'Practice the nuanced language required to meet the high expectations of VIP clients.' },
                { id: 140, title: 'Writing Professional Reports', desc: 'Learn to draft clear and concise incident reports and internal communications.' },
                { id: 148, title: 'Inter-departmental Leadership Communication', desc: 'Coordinate effectively with other teams using professional and direct language.' },
            ]
        }
    ];

    // Inline styles (can be moved to CSS/Tailwind later if preferred)
    const bodyStyle = {
      fontFamily: "'Segoe UI', sans-serif",
      background: '#f7f9fc',
      color: '#2c3e50',
      lineHeight: 1.6,
      position: 'relative', // Needed for absolute positioning of nav
      minHeight: '100vh', // Ensure body takes full height
      paddingTop: '5rem', // Add padding to prevent content from hiding under nav
    };

    const headerStyle = {
      textAlign: 'center',
      padding: '40px 20px',
      background: '#1a362d', // Dark green
      color: '#d4af37', // Gold
    };

    const headerH1Style = {
      fontSize: '28px',
      textShadow: '1px 1px 2px rgba(0,0,0,0.4)',
    };

    const containerStyle = {
      maxWidth: '1000px',
      margin: '40px auto',
      padding: '30px',
    };

    const pathwayStyle = {
      background: 'white',
      padding: '30px',
      borderRadius: '12px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
    };

    const phaseStyle = {
      margin: '30px 0',
      padding: '20px',
      background: '#f8f9fa',
      borderLeft: '4px solid #d4af37', // Gold border
      borderRadius: '8px',
    };

     const phaseH3Style = {
      color: '#1a362d', // Dark green
    };

    const ulStyle = {
      margin: '10px 0',
      paddingLeft: '20px',
    };

    const liStyle = {
      margin: '8px 0',
    };

    const exampleUnitStyle = {
      margin: '30px 0',
      padding: '20px',
      background: '#f8f9fa',
      borderRadius: '8px',
      border: '1px dashed #d4af37', // Gold dashed border
      textAlign: 'center',
    };

    const exampleUnitH4Style = {
       color: '#1a362d', // Dark green
    };

    const footerStyle = {
      textAlign: 'center',
      padding: '40px',
      background: '#1a362d', // Dark green
      color: 'white',
      marginTop: '60px',
    };

    // Nav styles (converted from CSS block)
    const topNavStyle = {
      position: 'absolute',
      top: '1rem',
      right: '1rem',
      zIndex: 10,
      backgroundColor: 'rgba(26, 54, 45, 0.8)', // Dark green transparent
      backdropFilter: 'blur(8px)',
      borderRadius: '2rem',
      padding: '0.5rem 1.5rem',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    };

    const topNavUlStyle = {
        display: 'flex',
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        gap: '1.5rem',
    };

    // Note: Link hover style needs CSS or JS event handlers in React
    const topNavLinkStyle = {
      color: '#d4af37', // Gold
      textDecoration: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      // transition: 'color 0.3s ease', // Add via CSS or libraries
    };


    return (
        <div style={bodyStyle}>
            {/* Top Right Navigation */}
            <nav style={topNavStyle}>
                <ul style={topNavUlStyle}>
                   {navLinks.map(link => (
                     <li key={link.label}>
                        {/* Use Link from react-router-dom if internal */}
                        <a href={link.href} style={topNavLinkStyle}
                           // Add hover effect with JS or CSS classes
                           onMouseEnter={(e) => e.target.style.color = '#f0e8c7'} // Light gold hover
                           onMouseLeave={(e) => e.target.style.color = '#d4af37'} // Original gold
                        >
                            {link.label}
                        </a>
                    </li>
                   ))}
                </ul>
            </nav>

            <header style={headerStyle}>
                <h1 style={headerH1Style}>🏨 Hotel English Mastery Pathway</h1>
                <p>A 148-Unit Curriculum for Professional Excellence</p>
            </header>

            <div style={containerStyle}>
                <div style={pathwayStyle}>
                    <p>This pathway is designed to empower hotel and hospitality professionals with the essential English skills needed to excel in a global environment. Our comprehensive 148-unit curriculum blends foundational grammar with practical, real-world communication scenarios, ensuring your team is confident and prepared for any guest interaction.</p>

                    {phases.map((phase, index) => (
                        <div key={index} style={phaseStyle}>
                            <h3 style={phaseH3Style}>{phase.title}</h3>
                            <p><strong>English Focus:</strong> {phase.focus}</p>
                            <ul style={ulStyle}>
                                {phase.units.map(unit => (
                                    <li key={unit.id} style={liStyle}>
                                        <strong>Unit {unit.id}: {unit.title}</strong><br />
                                        <em>{unit.desc}</em>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    {/* Call to Action */}
                    <div style={exampleUnitStyle}>
                        <h4 style={exampleUnitH4Style}>Ready to Elevate Your Team's Performance?</h4>
                        <p>Our comprehensive pathway equips your staff with the language skills to create memorable guest experiences and handle any challenge with confidence. Contact us today to get started.</p>
                        {/* Optional: Add a contact button/link here */}
                    </div>
                </div>
            </div>

            <footer style={footerStyle}>
                <p>© 2025 Aulice Academy. Reality is programmable. Smart people are its architects.</p>
            </footer>
        </div>
    );
};

export default HospitalityPathways;

